// Tiny fetch wrapper. Always uses same-origin (Vite dev proxies /api; prod serves from Express).
const BASE = '/api';

async function request(method, path, body) {
  const init = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (body !== undefined) init.body = JSON.stringify(body);
  const res = await fetch(BASE + path, init);
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!res.ok) {
    const msg = (data && data.error) || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  get:    (p)       => request('GET',    p),
  post:   (p, body) => request('POST',   p, body),
  patch:  (p, body) => request('PATCH',  p, body),
  put:    (p, body) => request('PUT',    p, body),
  delete: (p)       => request('DELETE', p),
};
